const SETTINGS_SET_LOGO = "SETTINGS_SET_LOGO";
const SETTINGS_SET_SPLASH = "SETTINGS_SET_SPLASH";

const SETTINGS_SET_SPLASH_LOAD = "SETTINGS_SET_SPLASH_LOAD";
const SETTINGS_SET_SPLASH_SUCCESS = "SETTINGS_SET_SPLASH_SUCCESS";
const SETTINGS_SET_SPLASH_FAIL = "SETTINGS_SET_SPLASH_FAIL";

const SETTINGS_SET_LOGO_LOAD = "SETTINGS_SET_LOGO_LOAD";
const SETTINGS_SET_LOGO_SUCCESS = "SETTINGS_SET_LOGO_SUCCESS";
const SETTINGS_SET_LOGO_FAIL = "SETTINGS_SET_LOGO_FAIL";

const SETTINGS_LOAD = "SETTINGS_LOAD";
const SETTINGS_LOAD_SUCCESS = "SETTINGS_LOAD_SUCCESS";
const SETTINGS_LOAD_FAIL = "SETTINGS_LOAD_FAIL";

const SETTINGS_SAVE = "SETTINGS_SAVE";
const SETTINGS_SAVE_SUCCESS = "SETTINGS_SAVE_SUCCESS";
const SETTINGS_SAVE_FAIL = "SETTINGS_LOAD_FAIL";

export const COMPANY_SETTING_LOAD = "COMPANY_SETTING_LOAD";
export const COMPANY_SETTING_LOAD_SUCCESS = "COMPANY_SETTING_LOAD_SUCCESS";
export const COMPANY_SETTING_LOAD_FAIL = "COMPANY_SETTING_LOAD_FAIL";

export const COMPANY_SETTING_LISTS_LOAD = "COMPANY_SETTING_LISTS_LOAD";
export const COMPANY_SETTING_LISTS_LOAD_SUCCESS = "COMPANY_SETTING_LISTS_LOAD_SUCCESS";
export const COMPANY_SETTING_LISTS_LOAD_FAIL = "COMPANY_SETTING_LISTS_LOAD_FAIL";

export const COMPANY_DETAILS_SAVE = "COMPANY_DETAILS_SAVE";
export const COMPANY_DETAILS_SAVE_SUCCESS = "COMPANY_DETAILS_SAVE_SUCCESS";
export const COMPANY_DETAILS_SAVE_FAIL = "COMPANY_DETAILS_SAVE_FAIL";

export const COMPANY_SETTINGS_SAVE = "COMPANY_SETTINGS_SAVE";
export const COMPANY_SETTINGS_SAVE_SUCCESS = "COMPANY_SETTINGS_SAVE_SUCCESS";
export const COMPANY_SETTINGS_SAVE_FAIL = "COMPANY_SETTINGS_SAVE_FAIL";

export const ALL_RESTORANTS_LOAD = "ALL_RESTORANTS_LOAD";
export const ALL_RESTORANTS_LOAD_SUCCESS = "ALL_RESTORANTS_LOAD_SUCCESS";
export const ALL_RESTORANTS_LOAD_FAIL = "ALL_RESTORANTS_LOAD_FAIL"

export const ALL_TAX_LOAD = "ALL_TAX_LOAD";
export const ALL_TAX_LOAD_SUCCESS = "ALL_TAX_LOAD_SUCCESS";
export const ALL_TAX_LOAD_FAIL = "ALL_TAX_LOAD_FAIL";

export const TAX_LOAD = "TAX_LOAD";
export const TAX_LOAD_SUCCESS = "TAX_LOAD_SUCCESS";
export const TAX_LOAD_FAIL = "TAX_LOAD_FAIL";

export const TAX_DELETE = "TAX_DELETE";
export const TAX_DELETE_SUCCESS = "TAX_DELETE_SUCCESS";
export const TAX_DELETE_FAIL = "TAX_DELETE_FAIL";

export const TAX_FIELD_CLEAR = "TAX_FIELD_CLEAR";

export const TAX_NEW_CREATE = "TAX_NEW_CREATE";
export const TAX_NEW_CREATE_SUCCESS = "TAX_NEW_CREATE_SUCCESS";
export const TAX_NEW_CREATE_FAIL = "TAX_NEW_CREATE_FAIL";

export const USER_PROFILE_LOAD = "USER_PROFILE_LOAD";
export const USER_PROFILE_LOAD_SUCCESS = "USER_PROFILE_LOAD_SUCCESS";
export const USER_PROFILE_LOAD_FAIL = "USER_PROFILE_LOAD_FAIL";

export const USER_PROFILE_UPDATE = "USER_PROFILE_UPDATE";
export const USER_PROFILE_UPDATE_SUCCESS = "USER_PROFILE_UPDATE_SUCCESS";
export const USER_PROFILE_UPDATE_FAIL = "USER_PROFILE_UPDATE_FAIL";

export const PASSWORD_UPDATE = "PASSWORD_UPDATE";
export const PASSWORD_UPDATE_SUCCESS = "PASSWORD_UPDATE_SUCCESS";
export const PASSWORD_UPDATE_FAIL = "PASSWORD_UPDATE_FAIL";

export const DEFAULT_PAYMENT_LOAD = "DEFAULT_PAYMENT_LOAD";
export const DEFAULT_PAYMENT_LOAD_SUCCESS = "DEFAULT_PAYMENT_LOAD_SUCCESS";
export const DEFAULT_PAYMENT_LOAD_FAIL = "DEFAULT_PAYMENT_LOAD_FAIL";

export const CHANGE_DEFAULT_PAYMENT_SYSTEM_SAVE = "CHANGE_DEFAULT_PAYMENT_SYSTEM_SAVE";
export const CHANGE_DEFAULT_PAYMENT_SYSTEM_SAVE_SUCCESS = "CHANGE_DEFAULT_PAYMENT_SYSTEM_SAVE_SUCCESS";
export const CHANGE_DEFAULT_PAYMENT_SYSTEM_SAVE_FAIL = "CHANGE_DEFAULT_PAYMENT_SYSTEM_SAVE_FAIL";

export const STRIPE_SYSTEM_DEAUTHORIZE = "STRIPE_SYSTEM_DEAUTHORIZE";
export const STRIPE_SYSTEM_DEAUTHORIZE_SUCCESS = "STRIPE_SYSTEM_DEAUTHORIZE_SUCCESS";
export const STRIPE_SYSTEM_DEAUTHORIZE_FAIL = "STRIPE_SYSTEM_DEAUTHORIZE_FAIL";

export const YOOKASA_SYSTEM_DEAUTHORIZE = "YOOKASA_SYSTEM_DEAUTHORIZE";
export const YOOKASA_SYSTEM_DEAUTHORIZE_SUCCESS = "YOOKASA_SYSTEM_DEAUTHORIZE_SUCCESS";
export const YOOKASA_SYSTEM_DEAUTHORIZE_FAIL = "YOOKASA_SYSTEM_DEAUTHORIZE_FAIL";

export const AMERIABANK_ACCOUNT_SAVE = "AMERIABANK_ACCOUNT_SAVE";
export const AMERIABANK_ACCOUNT_SAVE_SUCCESS = "AMERIABANK_ACCOUNT_SAVE_SUCCESS";
export const AMERIABANK_ACCOUNT_SAVE_FAIL = "AMERIABANK_ACCOUNT_SAVE_FAIL";

export const AMERIABANK_ACCOUNT_DELETE = "AMERIABANK_ACCOUNT_DELETE";
export const AMERIABANK_ACCOUNT_DELETE_SUCCESS = "AMERIABANK_ACCOUNT_DELETE_SUCCESS";
export const AMERIABANK_ACCOUNT_DELETE_FAIL = "AMERIABANK_ACCOUNT_DELETE_FAIL";

export const LOGOUT_SESSIONS = "LOGOUT_SESSIONS";
export const LOGOUT_SESSIONS_SUCCESS = "LOGOUT_SESSIONS_SUCCESS";
export const LOGOUT_SESSIONS_FAIL = "LOGOUT_SESSIONS_FAIL";

export const TWO_FACTOR_AUTH_CONFIRM_PASSWORD = "TWO_FACTOR_AUTH_CONFIRM_PASSWORD";
export const TWO_FACTOR_AUTH_CONFIRM_PASSWORD_SUCCESS = "TWO_FACTOR_AUTH_CONFIRM_PASSWORD_SUCCESS";
export const TWO_FACTOR_AUTH_CONFIRM_PASSWORD_FAIL = "TWO_FACTOR_AUTH_CONFIRM_PASSWORD_FAIL";

export const REGENERATE_CODE = "REGENERATE_CODE";
export const REGENERATE_CODE_SUCCESS = "REGENERATE_CODE_SUCCESS";
export const REGENERATE_CODE_FAIL = "REGENERATE_CODE_FAIL";

export const DELETE_ACCOUNT = "DELETE_ACCOUNT";
export const DELETE_ACCOUNT_SUCCESS = "DELETE_ACCOUNT_SUCCESS";
export const DELETE_ACCOUNT_FAIL = "DELETE_ACCOUNT_FAIL";


export const onSettingsSetLogo = (value) => ({ type: SETTINGS_SET_LOGO, value, });
export const onSettingsSetSplash = (value) => ({ type: SETTINGS_SET_SPLASH, value, });

export const onSettingsSetSplashLoad = () => ({ type: SETTINGS_SET_SPLASH_LOAD, });
export const onSettingsSetSplashSuccess = (response) => ({ type: SETTINGS_SET_SPLASH_SUCCESS, response, });
export const onSettingsSetSplashFail = (e) => ({ type: SETTINGS_SET_SPLASH_FAIL, e, });

export const onSettingsSetLogoLoad = () => ({ type: SETTINGS_SET_LOGO_LOAD });
export const onSettingsSetLogoSuccess = (response) => ({ type: SETTINGS_SET_LOGO_SUCCESS, response, });
export const onSettingsSetLogoFail = (e) => ({type: SETTINGS_SET_LOGO_FAIL,e,});

export const onSettingsLoad = () => ({ type: SETTINGS_LOAD });
export const onSettingsLoadSuccess = (response) => ({type: SETTINGS_LOAD_SUCCESS, response,});
export const onSettingsLoadFail = (e) => ({ type: SETTINGS_LOAD_FAIL, e });

export const onSettingsSave = () => ({ type: SETTINGS_SAVE });
export const onSettingsSaveSuccess = (response) => ({ type: SETTINGS_SAVE_SUCCESS, response,});
export const onSettingsSaveFail = (e) => ({ type: SETTINGS_SAVE_FAIL, e });

export const onCompanySettingLoad = () => ({type: COMPANY_SETTING_LOAD })
export const onCompanySettingLoadSuccess = (response) => ({type: COMPANY_SETTING_LOAD_SUCCESS, response })
export const onCompanySettingLoadFail = (e) => ({type: COMPANY_SETTING_LOAD_FAIL, e })

export const onCompanySettingListsLoad = () => ({type: COMPANY_SETTING_LISTS_LOAD })
export const onCompanySettingListsLoadSuccess = (response) => ({type: COMPANY_SETTING_LISTS_LOAD_SUCCESS, response })
export const onCompanySettingListsLoadFail = (e) => ({type: COMPANY_SETTING_LISTS_LOAD_FAIL, e })

export const onCompanyDetailsSave = (values) => ({type: COMPANY_DETAILS_SAVE, values});
export const onCompanyDetailsSaveSuccess = (response) => ({type: COMPANY_DETAILS_SAVE_SUCCESS, response,});
export const onCompanyDetailsSaveFail = (e) => ({type: COMPANY_DETAILS_SAVE_FAIL, e,});

export const onCompanySettingsSave = (values) => ({type: COMPANY_SETTINGS_SAVE, values});
export const onCompanySettingsSaveSuccess = (response) => ({type: COMPANY_SETTINGS_SAVE_SUCCESS, response,});
export const onCompanySettingsSaveFail = (e) => ({type: COMPANY_SETTINGS_SAVE_FAIL, e,});

export const onAllRestorantsLoad = () => ({ type: ALL_RESTORANTS_LOAD });
export const onAllRestorantsLoadSuccess = (response) => ({type: ALL_RESTORANTS_LOAD_SUCCESS, response});
export const onAllRestorantsLoadFail = (e) => ({ type: ALL_RESTORANTS_LOAD_FAIL, e });

export const onAllTaxLoad = () => ({ type: ALL_TAX_LOAD });
export const onAllTaxLoadSuccess = (response) => ({type: ALL_TAX_LOAD_SUCCESS, response});
export const onAllTaxLoadFail = (e) => ({ type: ALL_TAX_LOAD_FAIL, e });

export const onTaxLoad = (taxId) => ({ type: TAX_LOAD, taxId });
export const onTaxLoadSuccess = (response) => ({type: TAX_LOAD_SUCCESS, response,});
export const onTaxLoadFail = (e) => ({ type: TAX_LOAD_FAIL, e });

export const onTaxDelete = (taxId) => ({ type: TAX_DELETE, taxId });
export const onTaxDeleteSuccess = (response) => ({type: TAX_DELETE_SUCCESS, response,});
export const onTaxDeleteFail = (e) => ({ type: TAX_DELETE_FAIL, e });

export const onTaxFieldClear = ()=>({ type: TAX_FIELD_CLEAR})

export const onTaxNewCreate = (taxId, values, is_included, isCheckAll, is_enable, selectedIds, all_future_locations ) => ({
                                type: TAX_NEW_CREATE, taxId, values, is_included, isCheckAll,  
                                is_enable, selectedIds, all_future_locations});
export const onTaxNewCreateSuccess = (response) => ({type: TAX_NEW_CREATE_SUCCESS, response,});
export const onTaxNewCreateFail = (e) => ({type: TAX_NEW_CREATE_FAIL, e,});

export const onUserProfileLoad = () => ({type: USER_PROFILE_LOAD});
export const onUserProfileLoadSuccess = (response) => ({type: USER_PROFILE_LOAD_SUCCESS, response,});
export const onUserProfileLoadFail = (e) => ({type: USER_PROFILE_LOAD_FAIL, e,});

export const onUserProfileUpdate = (values) => ({type: USER_PROFILE_UPDATE, values,});
export const onUserProfileUpdateSuccess = (response) => ({type: USER_PROFILE_UPDATE_SUCCESS, response,});
export const onUserProfileUpdateFail = (e) => ({type: USER_PROFILE_UPDATE_FAIL, e,});

export const onPasswordUpdate = (values) => ({type: PASSWORD_UPDATE, values,});
export const onPasswordUpdateSuccess = (response) => ({type: PASSWORD_UPDATE_SUCCESS, response,});
export const onPasswordUpdateFail = (e) => ({type: PASSWORD_UPDATE_FAIL, e,});

export const onDefaultPaymentLoad = () => ({ type: DEFAULT_PAYMENT_LOAD });
export const onDefaultPaymentLoadSuccess = (response) => ({type: DEFAULT_PAYMENT_LOAD_SUCCESS, response,});
export const onDefaultPaymentLoadFail = (e) => ({ type: DEFAULT_PAYMENT_LOAD_FAIL, e });

export const onChangeDefaultPaymentSystemSave = (params) => ({type: CHANGE_DEFAULT_PAYMENT_SYSTEM_SAVE, params});
export const onChangeDefaultPaymentSystemSaveSuccess = (response) => ({type: CHANGE_DEFAULT_PAYMENT_SYSTEM_SAVE_SUCCESS, response,});
export const onChangeDefaultPaymentSystemSaveFail = (e) => ({type: CHANGE_DEFAULT_PAYMENT_SYSTEM_SAVE_FAIL, e,});

export const onStripeSystemDeauthorize = (accountId) => ({type: STRIPE_SYSTEM_DEAUTHORIZE, accountId,});
export const onStripeSystemDeauthorizeSuccess = (response) => ({type: STRIPE_SYSTEM_DEAUTHORIZE_SUCCESS, response,});
export const onStripeSystemDeauthorizeFail = (e) => ({type: STRIPE_SYSTEM_DEAUTHORIZE_FAIL, e,});

export const onYookassaSystemDeauthorize = (accountId) => ({type: YOOKASA_SYSTEM_DEAUTHORIZE, accountId,});
export const onYookassaSystemDeauthorizeSuccess = (response) => ({type: YOOKASA_SYSTEM_DEAUTHORIZE_SUCCESS, response,});
export const onYookassaSystemDeauthorizeFail = (e) => ({type: YOOKASA_SYSTEM_DEAUTHORIZE_FAIL, e,});

export const onAmeriabankAccountSave = (values) => ({type: AMERIABANK_ACCOUNT_SAVE, values});
export const onAmeriabankAccountSaveSuccess = (response) => ({type: AMERIABANK_ACCOUNT_SAVE_SUCCESS, response,});
export const onAmeriabankAccountSaveFail = (e) => ({type: AMERIABANK_ACCOUNT_SAVE_FAIL, e,});

export const onAmeriabankAccountDelete = (values) => ({type: AMERIABANK_ACCOUNT_DELETE, values});
export const onAmeriabankAccountDeleteSuccess = (response) => ({type: AMERIABANK_ACCOUNT_DELETE_SUCCESS, response,});
export const onAmeriabankAccountDeleteFail = (e) => ({type: AMERIABANK_ACCOUNT_DELETE_FAIL, e,});

export const onLogoutSessions = (pass) => ({type: LOGOUT_SESSIONS, pass});
export const onLogoutSessionsSuccess = (response) => ({type: LOGOUT_SESSIONS_SUCCESS, response,});
export const onLogoutSessionsFail = (e) => ({type: LOGOUT_SESSIONS_FAIL, e,});

export const TwoFactorAuthConfirmPassword = (pass, is_regenerate) => ({type: TWO_FACTOR_AUTH_CONFIRM_PASSWORD, pass, is_regenerate});
export const TwoFactorAuthConfirmPasswordSuccess = (response) => ({type: TWO_FACTOR_AUTH_CONFIRM_PASSWORD_SUCCESS, response,});
export const TwoFactorAuthConfirmPasswordFail = (e) => ({type: TWO_FACTOR_AUTH_CONFIRM_PASSWORD_FAIL, e,});

export const onRegenerateCode = (pass) => ({type: REGENERATE_CODE, pass});
export const onRegenerateCodeSuccess = (response) => ({type: REGENERATE_CODE_SUCCESS, response,});
export const onRegenerateCodeFail = (e) => ({type: REGENERATE_CODE_FAIL, e,});

export const onDeleteAccount = (pass) => ({type: DELETE_ACCOUNT, pass});
export const onDeleteAccountSuccess = (response) => ({type: DELETE_ACCOUNT_SUCCESS, response,});
export const onDeleteAccountFail = (e) => ({type: DELETE_ACCOUNT_FAIL, e,});